export default "__VITE_ASSET__d3a264b1__"